import { Observable } from 'rxjs';
import { ApiService } from '@elight/client/shared/data-access/common';
import { DivisionWithRateDTO } from '@elight/client/shared/data-access/users';

export class SyncableToDivisionsApiService<T> extends ApiService<T> {
    public getDivisions(
        id: string,
        parentId?: string
    ): Observable<DivisionWithRateDTO[]> {
        const url = this.getBaseUrl(parentId);
        return this.httpClient.get(`${url}/${id}/divisions`) as Observable<
            DivisionWithRateDTO[]
        >;
    }

    public syncToDivisions(
        id: string,
        divisions: string[],
        additionalData: {},
        parentId?: string
    ) {
        const url = this.getBaseUrl(parentId);

        return this.httpClient.post(`${url}/sync-divisions`, {
            id,
            divisions,
            additionalData,
        });
    }

    public removeFromDivisions(
        id: string,
        divisions: string[],
        parentId?: string
    ) {
        const url = this.getBaseUrl(parentId);

        return this.httpClient.post(`${url}/remove-from-divisions`, {
            id: id,
            divisions: divisions,
        });
    }
}
